import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { creditScoreService } from '../../services/creditScore.service';
import CustomerCreditScore from '../customer-page/CustomerCreditScore';
import CreditScoreScroll from './CreditScoreScroll';
import { GetCreditScoreList, SetCreditScoreList } from '../../store/creditScoreAtom';

function CreditScoreDetailsPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const getCreditScore = GetCreditScoreList();
  const setCreditScore = SetCreditScoreList();
  const { pathname } = useLocation();
  const url = pathname.split('/');
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];

  useEffect(() => {
    let isMounted = true;
    if (!getCreditScore.credit_score?.length) {
      creditScoreService.getCreditScoreList().then(res => {
        if (res?.data && isMounted) {
          setCreditScore(res.data);
        }
      });
    }
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadDetails = () => {
    setLoading(true);
    creditScoreService
      .getCreditScoreDetails(id)
      .then(res => {
        const list = res?.data?.credit_score ?? [];
        setDetails(list.find(item => String(item?.customer_id) === String(id)) ?? null);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    document.title = 'Credit Score Details';
    loadDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  function viewItemDetails(customerId) {
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${customerId}`);
  }

  return (
    <div className="min-h-screen bg-gray-50 p-4 sm:p-6">
      <div className="mx-auto max-w-7xl">
        <div className="mb-6 flex flex-row items-center justify-between">
          <div>
            <h2 className="text-lg font-bold">{details?.customer_full_name ?? 'Credit Score Details'}</h2>
            {details && (
              <span className={details.customer_status_name === 'Active' ? 'text-sm font-bold text-green-500' : 'text-sm text-gray-500'}>
                {details.customer_status_name}
              </span>
            )}
          </div>
          <button onClick={() => navigate(-1)} className="btn-light btn">
            Back
          </button>
        </div>

        <div className="flex flex-col gap-6 lg:flex-row">
          <div className="w-full flex-shrink-0 lg:w-64">
            <CreditScoreScroll viewItemDetails={viewItemDetails} />
          </div>

          <div className="min-w-0 flex-1">
            <CustomerCreditScore customer_id={id} data={details} loading={loading} onReload={loadDetails} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreditScoreDetailsPage;
